import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import DarkBackdrop from '../../assets/images/login/background-dark.jpg';
import LightBackdrop from '../../assets/images/login/background.jpg';
import { ReactComponent as FeaturesImage } from '../../assets/images/login/features.svg';
import { ReactComponent as LaptopImage } from '../../assets/images/login/laptop.svg';
import ThemeContext from '../../contexts/theme-context/ThemeContext';

/**
 * AuthLayout component
 * @returns {any} The rendered AuthLayout component.
 * @description AuthLayout component is a layout component for authentication pages.
 */
function AuthLayout(): React.JSX.Element {
  const { t, i18n } = useTranslation('loginV2');
  const { theme } = useContext(ThemeContext);

  /**
   * getBackdropImage
   * @returns {string} The backdrop image.
   */
  const getBackdropImage = () => {
    return theme === 'light' ? LightBackdrop : DarkBackdrop;
  };
  return (
    <div className="auth-layout-wrapper" dir={i18n.dir()}>
      <div className="auth-layout-content">
        <div className="auth-layout-content-left">
          <div className="auth-layout-content-top">
            <LaptopImage className="laptop-image" />
            <h1 className="title">{t('customizeDashboard')}</h1>
            <p className="description">
              {t('customizeYourDashboardForYour')}
              <span className="highlight">{t('comfortQuickAccess')}</span>
            </p>
          </div>
          <div className="auth-layout-content-bottom">
            <div key={i18n.dir()} className="features-marquee">
              {[1, 2].map((trackIndex) => (
                <div key={trackIndex} aria-hidden={trackIndex === 2} className="features-track">
                  {[1, 2, 3, 4].map((imageIndex) => (
                    <FeaturesImage key={imageIndex} className="features-image" />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="auth-layout-content-right">
          <Outlet />
        </div>
      </div>
      <div className="auth-layout-backdrop">
        <img src={getBackdropImage()} alt="" className="backdrop-image" />
      </div>
    </div>
  );
}

export default AuthLayout;
